import clsx from "clsx";
import __ from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import { DEFAULT_FILTER_VALUE, DEFAULT_SELECTED_SESSION_TYPE, LOCAL_STORAGE_KEYS, RouteName, SESSION_TYPES } from "../../../../constants/Constants";
import { Localize } from "../../Localize";
import { Localize as AriaLocalize } from "../../../../shared/ariaLabelLocalize";
import useMenuKeyboardNav from "../../../../hooks/useMenuKeyboardNav";

import storage from "../../../../services/storage";

const StatusFilter = (props) => {
    const {
        statusChangeHandler,
        language,
        isDiscardChanged
    } = props;

    const params = useParams();
    const history = useHistory();

    const [localisedValues, setLocalisedValues] = useState({});
    const { triggerRef, menuRef } = useMenuKeyboardNav();

    const [selectedFilter, setSelectedFilter] = useState(storage.has(LOCAL_STORAGE_KEYS.SESSION_FILTER) ? storage.get(LOCAL_STORAGE_KEYS.SESSION_FILTER) : DEFAULT_FILTER_VALUE);// 1=All session, 2=Active sessions, 3=Upcoming sessions, 4=Closed sessons, 5=Archived sessions,
    const [filterTooltip, setFilterTooltip] = useState('');
    const [isFilterSelected, setIsFilterSelected] = useState("");

    useEffect(() => {
        const curLang = language.selectedlanguage;
        const localisedObj = Localize[curLang.id];
        setLocalisedValues(localisedObj);
        setFilterTooltip(localisedObj[SESSION_TYPES.find((sessionType) => sessionType.value === selectedFilter).langkey]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language.selectedlanguage]);

    const sessionFilterChangeHandler = (value) => {
        setIsFilterSelected("selected")

        setTimeout(()=> {
            setIsFilterSelected("")
        },500)

        if (selectedFilter !== value) {
            if (!__.isEmpty(params) && !isDiscardChanged) {
                history.push(RouteName.SESSIONS);
            }
            setSelectedFilter(value);
            setFilterTooltip(localisedValues[SESSION_TYPES.find((sessionType) => sessionType.value === value).langkey]);
            statusChangeHandler(value);
        }
    }

    const filterLabel = (AriaLocalize[language.selectedlanguage?.id] || AriaLocalize['en_US']).filter_sessions_currently.replace('{value}', filterTooltip);
    const filterTooltipText = `${localisedValues['filter']}: ${filterTooltip.charAt(0).toUpperCase()}${filterTooltip.slice(1)}`;

    return (
        <>
            {!__.isEmpty(localisedValues) &&
                <div className="filter-box all-filter-box custom-tooltip right-tooltip tooltip-auto-width m-hide">
                    <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle triangle-none" type="button"
                            id="session-status-filter" data-testid="session-status-filter" data-bs-toggle="dropdown" aria-haspopup="menu" aria-expanded="false"
                            aria-label={filterLabel}
                            ref={triggerRef}>
                            <span className="filter-btn-icon icon-filter-result" aria-hidden="true"></span>
                            <span className="filter-btn-text">{filterTooltip}</span>
                            <span className="dropdown-toggle-arrow icon-arrow-down" aria-hidden="true"></span>
                        </button>
                        <div className="dropdown-menu" data-testid="session-status-filter-dropdown" aria-labelledby="session-status-filter"
                            ref={menuRef} role="menu">
                            <div className="dropdown-menu-in side-padding">
                                <ul role="none">
                                    {SESSION_TYPES.map((sessionType) => (
                                        <li className={clsx("filter-mark", sessionType.class, sessionType.value === selectedFilter && "active")} key={sessionType.name} role="none">
                                            {/* eslint-disable-next-line */}
                                            <a className="dropdown-item" href={void(0)} onClick={() => sessionFilterChangeHandler(sessionType.value)}
                                                role="menuitemradio" aria-checked={sessionType.value === selectedFilter} tabIndex={-1}>
                                                {localisedValues[sessionType.langkey]}
                                                {sessionType.value === selectedFilter && sessionType.name === DEFAULT_SELECTED_SESSION_TYPE &&
                                                    <span className="check-icon icon-check" aria-hidden="true"></span>
                                                }
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        {isFilterSelected !== "selected" && <div className="custom-tooltip-content">
                            <div className="custom-tooltip-in">
                                <p>{filterTooltipText}</p>
                            </div>
                        </div>}
                    </div>
                </div>
            }
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

StatusFilter.propTypes = {
    statusChangeHandler: PropTypes.func,
    language: PropTypes.object,
    isDiscardChanged: PropTypes.bool,
}

export default connect(mapStateToProps, null)(StatusFilter);